import { render, staticRenderFns } from "./EventItemForm.vue?vue&type=template&id=25ce1f63&scoped=true"
import script from "./EventItemForm.vue?vue&type=script&lang=ts"
export * from "./EventItemForm.vue?vue&type=script&lang=ts"
import style0 from "./EventItemForm.vue?vue&type=style&index=0&id=25ce1f63&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ce1f63",
  null
  
)

export default component.exports